import { INhomLopUpdateTKBRequest } from "../../model/request/tkb/INhomLopUpdateTKBRequest";
import { ISuKienSelectRequest } from "../../model/request/tkb/ISuKienSelectRequest";
import { ISuKienUpdateRequest } from "../../model/request/tkb/ISuKienUpdateRequest";
import { ITkbTraCuuRequest } from "../../model/request/tkb/ITkbTraCuuRequest";
import { IXepTKBSelectByBoMonRequest } from "../../model/request/tkb/IXepTKBSelectByBoMonRequest";
import { ICheckTrungPhongRequest } from "../../model/request/tkb/ICheckTrungPhongRequest";
import { apiClient } from "../apiClient";
export const XEP_TKB = "xep-tkb";
export const REPORT_XEP_TKB = "report/xep-tkb";
export const xepTkbApi = {
    SelectXepTKB: (request: IXepTKBSelectByBoMonRequest) => apiClient.post(`${XEP_TKB}/select`, request),
    SelectPhanPhong: (request: ISuKienSelectRequest) => apiClient.post(`${XEP_TKB}/select/xep-phong`, request),
    UpdateTKB: (request: ISuKienUpdateRequest) => apiClient.put(`${XEP_TKB}`, request),
    UpdateGiaoVien: (request: ISuKienUpdateRequest) => apiClient.put(`${XEP_TKB}/giao-vien`, request),
    UpdatePhongHoc: (request: ISuKienUpdateRequest) => apiClient.put(`${XEP_TKB}/phong-hoc`, request),
    NhomLopUpdateSuKienAsync: (request: INhomLopUpdateTKBRequest) => apiClient.put(`${XEP_TKB}/nhom-lop`, request),
    TraCuuAsync: (request: ITkbTraCuuRequest) => apiClient.post(`${XEP_TKB}/tra-cuu`, request),
    SelectXepTKBLopTC: (request: ISuKienSelectRequest) => apiClient.post(`${XEP_TKB}/select-xep-tkb-loptc`, request),
    GetHtmlPrintPhieuBaoGiang: (request: IXepTKBSelectByBoMonRequest) => apiClient.post(`${REPORT_XEP_TKB}/phieu-bao-giang/html`, request),

    // ===== Check trùng & warm-up cache (gộp từ thoiKhoaBieuApi) =====
    SelectByKyDangKy: (ky_dang_kys: number[]) => apiClient.post(`${XEP_TKB}/ky-dang-ky`, ky_dang_kys),
    CheckTrungPhong: (request: ICheckTrungPhongRequest) => apiClient.post(`${XEP_TKB}/check-trung-phong`, request),
    CheckTrungPhongLop: (request: { ky_dang_ky: number; id_phong: number; id_lop_tc: number }) =>
        apiClient.post(`${XEP_TKB}/check-trung-phong-lop`, request),
    CheckTrungPhongLichThi: (request: {
        ky_dang_ky: number;
        phongThis: { id_phong: number; ngay_thi: string; gio_thi?: string; so_phut_thi: number; exclude_id_dot_thi_phong: number }[];
    }) => apiClient.post(`${XEP_TKB}/check-trung-phong-lich-thi`, request),
    CheckTrungCanBo: (request: {
        ky_dang_ky: number; id_cbs: string[];
        thu: number; tiet: number; so_tiet: number;
        tu_ngay: string; den_ngay: string; tu_gio?: string; den_gio?: string;
        exclude_id_lop_tc: number;
    }) => apiClient.post(`${XEP_TKB}/check-trung-can-bo`, request),
    CheckTrungCanBoLichThi: (request: {
        ky_dang_ky: number; id_cbs: string[];
        ngay_thi: string; gio_thi?: string; so_phut_thi: number;
        exclude_id_dot_thi_phong: number;
    }) => apiClient.post(`${XEP_TKB}/check-trung-can-bo-lich-thi`, request),
    WarmUpCache: (ky_dang_ky: number, isRefreshCache: boolean = true) =>
        apiClient.post(`${XEP_TKB}/warm-up/${ky_dang_ky}?isRefreshCache=${isRefreshCache}`, {}),


}